import styled from 'styled-components';

export const PaymentOptions = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    gap: 8px;
  }
`;
